import { DynamicField, DynamicSections, Facility, PaymentDetailType } from '@cargos/sprintpay-models';
import moment from 'moment';
import { Detail } from '../details';
import { UserPayments } from '../payment/payment';
import { UserProperties } from './user';

export class KNUser implements UserProperties, UserPayments {
    constructor(
        private apis: Record<string, string>,
        public dynamicFields: DynamicField[] = [],
        public dynamicSections: DynamicSections[] = []
    ) {
        const paymentURL = this.apis['payments'];

        this.dynamicSections = [
            {
                id: 1,
                label: 'KN Customer Reference',
                orderNumber: 0,
                company: { id: 57, name: 'KN' },
                emailDomain: null,
            },
            {
                id: 2,
                label: 'Payment Details',
                orderNumber: 1,
                company: { id: 57, name: 'KN' },
                emailDomain: null,
            },
            {
                id: 3,
                label: 'Customer Reference',
                orderNumber: 2,
                company: { id: 57, name: 'KN' },
                emailDomain: null,
            },
        ];
        this.dynamicFields = [
            {
                name: 'customerRef',
                label: 'ACON FILE Number',
                section: 2,
                fieldType: 'input',
                company: undefined,
                emailDomain: null,
                isDisabled: false,
                isReplacement: false,
                isHidden: false,
                subLabel: '',
                tooltipTitle: '',
                tooltipMessage:
                    'Your own personal reference # so you can remember this payment. For example your file #.',
                validations: [
                    {
                        id: 0,
                        name: 'pattern',
                        value: [/^\d{10}(-\d{4})$/, /^\d{2}(-\d{4})(-\d{3}(\.\d{3}))$/, /^[a-zA-z]{2}\d{8}(-\d{4})$/],
                        message:
                            'Enter as either: 10 number - 4 numeric (1040942865-4952), 2 numeric - 4 numeric -3 numeric . 3 numeric (21-3830-108.011), 2 alpha + 8 numeric - 4 numeric (US00074747-4978)',
                        title: null,
                        type: 'VALIDATION',
                    },
                    {
                        id: 1,
                        name: 'maxlength',
                        value: '255',
                        message: 'Maximum length exceeded (255 characters maximum)',
                        title: null,
                        type: 'VALIDATION',
                    },
                    {
                        id: 2,
                        name: 'required',
                        value: 'true',
                        message: 'Please enter your ACON FILE Number.',
                        title: null,
                        type: 'VALIDATION',
                    },
                ],
            },
            {
                name: 'locationId',
                label: 'Location',
                section: 0,
                fieldType: 'dropdown',
                company: undefined,
                emailDomain: null,
                isDisabled: false,
                isReplacement: false,
                isHidden: false,
                subLabel: '',
                tooltipTitle: '',
                tooltipMessage: '',
                apiProviderData: `${paymentURL}/customer/approval-flow/information`,
                validations: [
                    {
                        id: 1,
                        name: 'required',
                        value: 'true',
                        message: 'Required field',
                        title: null,
                        type: 'VALIDATION',
                    },
                ],
            },
        ];
    }

    public getPaymentDetails = (payment: PaymentDetailType, facility: Facility, id: string): Detail[] => [
        {
            label: facility.externalLookup ? 'File Number' : 'Second facility reference #',
            value: payment.hawb ? payment.hawb : 'N/A',
            show: !facility.externalLookup && !id,
        },
        { label: 'Paid To', value: payment.paidTo ? payment.paidTo : 'N/A', show: true },
        {
            label: 'Cargo facility',
            value: facility.name ? facility.name : 'N/A',
            show: true,
        },
        {
            label: 'Amount',
            value: payment.amount ? '$' + payment.amount.toFixed(2) : 'N/A',
            show: true,
        },
    ];

    public getPaymentCustomerReference = (
        payment: PaymentDetailType,
        customerReferenceLabel: string = ''
    ): Detail[] => [
        {
            label: customerReferenceLabel ? customerReferenceLabel : (this.dynamicFields[0]?.label ?? ''),
            value: payment.customerReference ? payment.customerReference : 'N/A',
            show: true,
        },
        {
            label: 'Payment Notification Email',
            value: payment.notificationEmail ? payment.notificationEmail : 'N/A',
            show: true,
        },
        { label: 'Notes', value: payment.notes ? payment.notes : 'N/A', show: true },
    ];

    public getCustomerInformation = (payment: PaymentDetailType): Detail[] => [
        {
            label: 'Customer Name',
            value: payment.customer ? payment.customer.name : 'N/A',
            show: true,
        },
        {
            label: 'Notification email',
            value: payment?.notificationEmail ? payment?.notificationEmail : 'N/A',
            show: true,
        },
        {
            label: 'Created Date',
            value: payment?.createdDate ? moment(payment?.createdDate).format('MMM DD, YYYY') : 'N/A',
            show: true,
        },
    ];

    public getCompanyCustomerReference = (payment: PaymentDetailType): Detail[] => [
        {
            label: 'Payment Amount',
            value: payment?.externalData?.type ?? 'N/A',
            show: !!(payment?.externalLookup && payment.id),
        },
        {
            label: 'Type',
            value: payment?.paymentType ?? 'N/A',
            show: !!(payment?.externalLookup && payment.id),
        },
        { label: 'Location', value: payment?.location ?? 'N/A', show: true },
    ];
}
